/**
 * Injects the riaComponent of current option into a payload
 * @param {*} payload
 * @param {*} settingsDefault
 */
export const addRiaComponentTo = (payload = {}, settingsDefault = {}) => {
  if (settingsDefault?.riaComponent) {
    const {riaComponent} = settingsDefault;

    return {...payload, riaComponent};
  }

  return payload;
};

export default {
  addRiaComponentTo,
};
